module.exports = __webpack_public_path__ + "static/media/宁波药材.1a17b33a.png";